import { apiAsset } from "../../../commons/inFormTypes";
import parse from 'html-react-parser';


export const truncate = (str, len) => {
    if (str?.length > len && str?.length > 0) {
        let new_str = str + " ";
        new_str = str?.substr(0, len);
        new_str = str?.substr(0, new_str.lastIndexOf(" "));
        new_str = new_str.length > 0 ? new_str : str?.substr(0, len);
        return new_str + "...";
    }
    return str;
};

const Topbox = (props) => {

    return (<> <div
        className="bg-topbox-background w-full h-[270px] mb-20  border-t-[0.1px] border-t-borderT pt-10 totop:mb-0 totop:h-[333px] totop:bg-cover totop:bg-no-repeat 2xl:mb-14 2xl:lg:mb-0 lg:h-[265px] lg:md:h-full ">
        <div className="flex flex-row px-[70px] w-full lg:px-[30px]  md:flex-col md:items-center lg:sm:px-[10px]">
            <div className="min-w-[360px] xs:min-w-[200px] xl:w-[33%] xl:lg:w-[30%] xl:lg:md:w-[90%] xl:lg:md:sm:w-[100%]">
                <img loading="lazy" src={apiAsset + props?.imgPath} className="w-[360px] h-[270px] rounded-3xl lg:w-[260px] lg:h-[190px] lg:md:w-[100%] lg:md:h-[290px]" />
            </div>
            <div className="mr-8 xl:w-[64%] xl:mr-[3%] xl:lg:w-[67%] xl:lg:md:w-[90%] xl:md:mr-0 md:my-5 xl:lg:md:sm:w-[100%]">
                <p className="font-IRANYekanMedium text-nextColorLight opacity-85 mb-2 text-l lg:text-[15px] lg:mb-[4px]">
                    {props?.secondTitle}
                </p>
                <p className="font-IRANYekanExtra text-nextColor text-2xl lg:text-[17px]">
                    {props.title}
                </p>
                <div className="">
                    <p className="text-white text-base text-justify font-IRANYekanMedium mt-3 leading-8 lg:text-[14px] lg:mt-[7px]">
                        {props.text ?
                            parse(truncate(props?.text, 350)):"متن خبر"}
                    </p>
                </div>
            </div>
        </div>
    </div> </>
    )
}

export default Topbox;